// extracted by mini-css-extract-plugin
export default {"root":"PlasmicPaidStatusCard_root__7HBPC","text":"PlasmicPaidStatusCard_text__jjOF0"};